export const initialProducts = {
    data: []
}

export const initialBasket = {
    products: [],
    quantity: 0
}

export const initialCheckout = {
    promoCode: '',
    promoData: []
}